import { Section, TextHeading2 } from '@ferreri/prever-component-lib';
import { PlanBenefitsList } from './PlanBenefitsList';

export const PlanBenefitsSection = () => (
  <Section>
    <TextHeading2>
      Planos <span translate="no">Prever Angelus</span>
    </TextHeading2>
    <PlanBenefitsList />
  </Section>
);
